<template>
  <ul>
    <li v-for="message in sortedMessages" :key="message.id">
      <View direction="column" gap="xs">
        <View justify="space-between">
          <Text variant="h4">{{ message.isSystem ? 'Tallo' : message.user?.name }}</Text>
          <View gap="xs">
            <Text variant="body-small" color="secondary">
              {{ useDateFormat(message.createdAt, 'MMM DD, hh:mm A') }}
            </Text>
            <View v-if="message.communicationChannel" gap="xs">
              <Text variant="body-small" color="secondary">∙</Text>
              <Text variant="body-small" color="secondary">Sent via {{ message.communicationChannel }}</Text>
            </View>
          </View>
        </View>
        <Text variant="body-medium">{{ message.content }}</Text>
      </View>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useDateFormat } from '@vueuse/core';
import { computed } from 'vue';

import { Text, View } from '@tallo/design-system';

import { ConversationDto } from '../models/conversation.interface';

const props = defineProps<{ conversation: ConversationDto }>();

const sortedMessages = computed(() => {
  return [...props.conversation.messages].sort((a, b) => {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  });
});
</script>

<style scoped lang="scss">
ul {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--t-spacing-lg);
}

li {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
